import { Tag } from 'antd'
import { DELIVERY_STATUSES } from '@Orders/constants'
import {
    getDeliveryStateColor,
    getDeliveryStateText,
} from '@Orders/OrderDetailsPage/logic'
import styles from '@Orders/OrderDetailsPage/styles.css'
import { salesOrder_salesOrder_shipments_items_trackingData } from '@Orders/OrderDetailsPage/Queries/__generated__/salesOrder'

import Text from '~/core/Text'
import Button from '~/core/Button'

export const ShipmentHeader = (
    trackingData: salesOrder_salesOrder_shipments_items_trackingData | null,
    trackingCodeUrl: string | undefined,
    shipmentCount: number,
    shipmentTotal: number,
) => {
    const titleShipment =
        shipmentTotal >= 1 ? (
            <Text className={styles.titleTextHeader}>
                Shipment {shipmentCount}
            </Text>
        ) : (
            ''
        )

    return trackingData ? (
        <>
            {titleShipment}
            {trackingData?.status !== DELIVERY_STATUSES.DELIVERED && (
                <Button
                    href={trackingCodeUrl}
                    name="track-shipment"
                    placement="shipment-header"
                    style={{ marginLeft: '10px', marginTop: '3px' }}
                    target="_blank"
                    data-test-target="track-shipment-btn"
                >
                    Track this shipment
                </Button>
            )}
            <Tag
                color={getDeliveryStateColor(trackingData?.status)}
                className={styles.deliveryTag}
            >
                {getDeliveryStateText(trackingData?.status)}
            </Tag>
        </>
    ) : (
        <>{titleShipment}</>
    )
}
